import React, { useEffect, useRef, useState } from 'react';

import styles from './tips-page.module.css';

import LoaderPage from '../../components/LoaderPage/LoaderPage';
import { addTipsBd, getTipsBd } from '../../firebase';
import HeaderBack from '../../components/HeaderBack/HeaderBack';

const TipsPage = () => {
  // console.log('TipsPage/render');

  const [notesText, setNotesText] = useState('');
  const [loaderPage, setLoaderPage] = useState(false);
  const [render, setRender] = useState(false);

  const [dataArray, setDataArray] = useState([
    // { id: 'id_1', title: 'title_1', text: 'text_1' },
  ]);

  // console.log(dataArray);

  // Потрібно щоб показувати кнопку зберегти в textarea
  const showSaveBtnRef = useRef(false);

  useEffect(() => {
    setLoaderPage(true);
    const fetchData = async () => {
      const tips = await getTipsBd();

      if (tips) {
        setDataArray(tips.text);
      } else {
        alert('Помилка при отримані даних з сервера.');
      }

      setLoaderPage(false);
    };
    fetchData();
  }, []);

  const onChangeText = (index, item, value) => {
    dataArray[index][item] = value;
    setRender(!render);
    if (!showSaveBtnRef.current) {
      showSaveBtnRef.current = true;
    }
  };

  const saveNotes = async (notesText, ifAlert = true) => {
    setLoaderPage(true);
    const isAddTipsBd = await addTipsBd(notesText);

    if (isAddTipsBd) {
      if (ifAlert) {
        alert('Збережено успішно');
      }
      showSaveBtnRef.current = false;
      setLoaderPage(false);
      return true;
    } else {
      alert('Помилка при збережені');
      showSaveBtnRef.current = false;
      setLoaderPage(false);
      return false;
    }
  };

  const addNotesItem = () => {
    const newData = [...dataArray, { id: new Date().getTime(), title: '', text: '' }];
    const isAddNotesBd = saveNotes(newData, false);
    if (isAddNotesBd) {
      setDataArray(newData);
    }
  };

  const deleteNotes = async (index) => {
    let isDelete = window.confirm('Видалити?');
    if (isDelete) {
      const data = [...dataArray];
      data.splice(index, 1);

      const isDelete = saveNotes(data, false);

      if (isDelete) {
        setDataArray(data);

        setRender(!render);
      }
    }
  };

  return (
    <>
      {/* -------------- Header ------------------------ */}
      <HeaderBack />
      {/* -------------- /Header ------------------------ */}
      <div className={styles.notes_wrapper}>
        {dataArray.map((item, index) => {
          return (
            <div key={item.id} className={styles.notes_item_wrapper}>
              <div className={styles.delete_notes} onClick={() => deleteNotes(index)}>
                <svg
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M3 3H18V18C18 19.1046 17.1046 20 16 20H5C3.89543 20 3 19.1046 3 18V3Z"
                    fill="#FF5C5E"></path>
                  <rect width="21" height="2" rx="1" fill="#FF5C5E"></rect>
                </svg>
              </div>
              Заголовок {index + 1}
              <input
                className={styles.input_title}
                value={dataArray[index].title}
                onChange={(e) => onChangeText(index, 'title', e.target.value)}
                type="text"></input>
              Текст
              <textarea
                className={styles.textarea}
                value={dataArray[index].text}
                rows="15"
                placeholder="Поради..."
                onChange={(e) => onChangeText(index, 'text', e.target.value)}></textarea>
            </div>
          );
        })}
        {showSaveBtnRef.current && (
          <button className={styles.notes_save_btn} onClick={() => saveNotes(dataArray)}>
            Зберегти
          </button>
        )}
        <svg
          onClick={() => addNotesItem(dataArray)}
          className={styles.interaction_item}
          width="35"
          height="36"
          viewBox="0 0 35 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <rect y="2.60376" width="34.7273" height="33.0189" rx="10" fill="#A22CA7" />
          <path
            d="M16.2182 26.4091V11.4091H18.7636V26.4091H16.2182ZM9.99089 20.1818V17.6364H24.9909V20.1818H9.99089Z"
            fill="white"
          />
        </svg>
      </div>
      {loaderPage && <LoaderPage />}
    </>
  );
};

export default TipsPage;
